import styled from '@emotion/styled';

const Footer = styled.footer`
	padding: 1rem 1.5rem;
	background: black;
	display: flex;
	justify-content: center;
`;

const Logo = styled.img`
	max-height: 2rem;
	object-fit: contain;
`;

export default function PoweredBlockDelta({ tenantLogo }: { tenantLogo: string }) {
	return (
		<Footer>
			<Logo src={tenantLogo} alt="Tenant logo" />
		</Footer>
	);
}
